/* eslint-disable @typescript-eslint/no-magic-numbers */
import { AbstractControl, ValidationErrors } from '@angular/forms';

export const MAX_PREVIOUS_DATE = 120;
export const MIN_BIRTH_YEAR = new Date().getFullYear() - MAX_PREVIOUS_DATE;
export const MAX_BIRTH_YEAR = new Date().getFullYear();

const yearRegex = /^[0-9]{4}$/;

const validateBirthYear = (birthYear: string): boolean => {
  const birthYearDate = new Date(birthYear).getFullYear();

  return yearRegex.test(birthYear) && birthYearDate >= MIN_BIRTH_YEAR && birthYearDate <= MAX_BIRTH_YEAR;
};

const BirthYearValidator = (formControl: AbstractControl): ValidationErrors | null => {
  const value = formControl && (formControl.value as string);

  if (!value) {
    return {};
  }

  const birthYear = !validateBirthYear(value);

  if (!birthYear) {
    return {};
  }

  return { birthYear };
};

export default BirthYearValidator;
